import TribesListView from 'src/components/common/explore/tribesListView';

const Tribes = () => {
  return <TribesListView />;
};

export default Tribes;
